import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon, { MessageCircle } from '../AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();
  const [phoneNumber, setPhoneNumber] = useState('');

  const footerLinks = [
    { label: 'Blogs', path: '/blogs' },
    { label: 'Reviews', path: '/reviews' },
    { label: 'FAQ', path: '/faq' },
    { label: 'About Us', path: '/about-us' },
    { label: 'Contact Us', path: '/contact-us' },
  ];

  const ourServices = [
    { label: 'Force Urbania', path: '/force-urbania' },
    { label: 'Tempo Traveller', path: '/tempo-traveller' },
    { label: 'Local Cab', path: '/local-cab' },
    { label: 'Taxi Tour Packages', path: '/tour-packages' },
    { label: 'Self drive car Rental Service', path: '/self-drive' },
    { label: 'Wedding Car', path: '/wedding-car' },
    { label: 'Yatra', path: '/yatra' },
    { label: 'Daily Pick and Drop Service', path: '/daily-pick-drop' },
    { label: 'Corporate Car Rental', path: '/corporate-car-rental' },
  ];

  const handleCallMe = () => {
    if (phoneNumber) {
      window.open(`tel:${phoneNumber}`, '_self');
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-8 sm:py-10 md:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {/* About Us Section */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">
              About Us
            </h3>
            <p className="text-xs sm:text-sm text-gray-300 leading-relaxed">
              <span className="font-semibold text-white">Advait Tour and Travels</span> is one of the leading tour and travel companies in Ludhiana. With an aim of fulfilling the transportation needs of the customers, we have been providing our clients the best cab booking services
            </p>
          </div>

          {/* Footer Links Section */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">
              Footer Links
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-xs sm:text-sm text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-2 group touch-manipulation"
                  >
                    <Icon
                      name="ChevronRight"
                      size={14}
                      className="group-hover:translate-x-1 transition-transform duration-200"
                    />
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Services Section */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">
              Our Services
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              {ourServices?.map((service) => (
                <li key={service?.label}>
                  <Link
                    to={service?.path}
                    className="text-xs sm:text-sm text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-2 group touch-manipulation"
                  >
                    <Icon
                      name="ChevronRight"
                      size={14}
                      className="group-hover:translate-x-1 transition-transform duration-200"
                    />
                    {service?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Us Section */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">
              Contact Us
            </h3>
            <div className="space-y-3 sm:space-y-4">
              <p className="text-base sm:text-lg font-semibold text-white">
                Hate filling out form?
              </p>
              <p className="text-xs sm:text-sm text-gray-300">
                Let's start speak with our expert.
              </p>

              {/* Expert Info Card */}
              <div className="rounded-lg p-3 sm:p-4 space-y-2 sm:space-y-3 border border-gray-700">
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                    <Icon name="User" size={24} className="text-blue-600 sm:w-8 sm:h-8" />
                  </div>
                  <div>
                    <p className="text-base sm:text-lg font-bold text-white">Harsh Nagpal</p>
                    <p className="text-xs text-gray-400">Managing Director & Owner</p>
                  </div>
                </div>

                {/* Contact Options */}
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-gray-300">
                    <Icon name="Phone" size={16} />
                    <span className="text-xs sm:text-sm font-semibold">Give a ring</span>
                  </div>
                  <a
                    href="tel:+917998666660"
                    className="text-blue-400 font-semibold text-xs sm:text-sm hover:underline block touch-manipulation"
                  >
                    +91-79986-66660
                  </a>

                  <div className="flex items-center gap-2 text-gray-300 mt-3">
                    <MessageCircle className="w-4 h-4" />
                    <span className="text-xs sm:text-sm font-semibold">WhatsApp</span>
                  </div>
                  <a
                    href="https://wa.me/917998666660"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-400 font-semibold text-xs sm:text-sm hover:underline block touch-manipulation"
                  >
                    +91-79986-66660
                  </a>

                  <div className="flex items-center gap-2 text-gray-300 mt-3">
                    <Icon name="Mail" size={16} />
                    <span className="text-xs sm:text-sm font-semibold">Email</span>
                  </div>
                  <a
                    href="mailto:Advaittourtravel666@gmail.com"
                    className="text-blue-400 font-semibold text-xs sm:text-sm hover:underline block break-all touch-manipulation"
                  >
                    Advaittourtravel666@gmail.com
                  </a>

                  <div className="flex items-center gap-2 text-gray-300 mt-3">
                    <Icon name="MapPin" size={16} />
                    <span className="text-xs sm:text-sm font-semibold">Address</span>
                  </div>
                  <p className="text-gray-300 text-xs sm:text-sm">
                    New Shivpuri, Ludhiana
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 sm:mt-10 md:mt-12">
          <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-5 md:py-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-3 sm:gap-4">
              <p className="text-xs sm:text-sm text-gray-400 text-center md:text-left">
                © {currentYear} <span className="font-semibold text-white">Advait Tour and Travels</span>. All rights reserved.
              </p>
              <div className="flex items-center gap-3 sm:gap-4">
                <Link to="/faq" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200 touch-manipulation">
                  FAQ
                </Link>
                <span className="text-gray-600">|</span>
                <Link to="/contact-us" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200 touch-manipulation">
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;